export const LEGACY_APP_MOVED_ROUTE = '/legacy-app-moved'
export const LEGACY_APP_HOME_ROUTE = '/landlord/my_units'

export const isLegacyAccessAllowed = (user?: { id?: number | string } | null): boolean => {
    const allowedId = Number(process.env.REACT_APP_BSO_USER_ID)
    const userId = Number(user?.id)

    return Number.isFinite(allowedId)
        && Number.isFinite(userId)
        && userId === allowedId
}
